


























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  QuestionItemForm,
  QuestionOptionForm,
  QuestionPreview,
  submitQuestion
} from "@/serve/question/question";
import {
  AnswerMap,
  buildSubmitItems,
  createAnswerMap,
  ExternalContext,
  getVisibleItems,
  hasAgeRule,
  hasExternalRules,
  hasGenderRule,
  isItemRequired,
  ItemAnswer,
  optionDisabled,
  optionSelected,
  QuestionRule,
  toggleOption,
  validateSubmitAnswers
} from "@/serve/question/questionRuleEngine";

@Component({
  name: "questionPreview"
})
export default class QuestionPreviewDialog extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop({ required: true }) public previewData!: QuestionPreview;

  public answers: AnswerMap = {};
  public checkerGender = "";
  public checkerAge: number | null = null;
  public submitLoading = false;
  public submitResult: any = null;

  public get innerVisible() {
    return this.visible;
  }

  public set innerVisible(value: boolean) {
    this.$emit("update:visible", value);
  }

  public get previewTitle() {
    return (this.previewData.question && this.previewData.question.questionName) || "";
  }

  public get rules(): QuestionRule[] {
    return this.previewData.rules || [];
  }

  public get hasGenderRule() {
    return hasGenderRule(this.rules);
  }

  public get hasAgeRule() {
    return hasAgeRule(this.rules);
  }

  public get hasExternalRules() {
    return hasExternalRules(this.rules);
  }

  public get externalContext(): ExternalContext {
    return {
      checkerGender: this.checkerGender,
      checkerAge: this.checkerAge
    };
  }

  public get visibleItems() {
    return getVisibleItems(this.previewData.items || [], this.rules, this.answers, this.externalContext);
  }

  @Watch("visible")
  public handleVisibleChange(value: boolean) {
    if (value) {
      this.initAnswers();
    }
  }

  public initAnswers() {
    this.answers = createAnswerMap(this.previewData.items || [], this.answers);
    this.submitResult = null;
  }

  public itemTypeLabel(type: string) {
    const map: { [key: string]: string } = {
      single: "单选",
      multiple: "多选",
      text: "填空"
    };
    return map[type] || type;
  }

  public answer(item: QuestionItemForm): ItemAnswer {
    const id = item.id as number;
    if (!this.answers[id]) {
      this.$set(this.answers, id, { answerText: "", options: [], optionInputs: {} });
    }
    return this.answers[id];
  }

  public optionSelected(item: QuestionItemForm, option: QuestionOptionForm) {
    return optionSelected(this.answer(item), option);
  }

  public optionDisabled(item: QuestionItemForm, option: QuestionOptionForm) {
    return optionDisabled(item, option, this.answer(item));
  }

  public toggleOption(item: QuestionItemForm, option: QuestionOptionForm) {
    toggleOption(item, option, this.answer(item));
  }

  public isRequired(item: QuestionItemForm) {
    return isItemRequired(item, this.rules, this.answers, this.externalContext);
  }

  public validateSubmit() {
    const message = validateSubmitAnswers(this.previewData.items || [], this.rules, this.answers, this.externalContext);
    if (message) {
      this.$message.warning(message);
      return false;
    }
    return true;
  }

  public async submitTest() {
    if (!this.previewData.question || !this.previewData.question.id || !this.validateSubmit()) {
      return;
    }
    this.submitLoading = true;
    try {
      const res = await submitQuestion({
        questionId: this.previewData.question.id,
        submitSource: "manage_test",
        checkerName: "后台测试",
        checkerGender: this.checkerGender,
        checkerAge: this.checkerAge,
        items: buildSubmitItems(this.visibleItems, this.answers)
      });
      if (res.success) {
        this.submitResult = res.data;
        this.$message.success("测试提交成功");
      } else {
        this.showApiMessage(res, "测试提交失败");
      }
    } finally {
      this.submitLoading = false;
    }
  }

  private showApiMessage(res: any, fallback: string, type: "error" | "warning" = "error") {
    if (res && res.__messageShown) {
      return;
    }
    this.$message[type]((res && res.msg) || fallback);
  }
}
